export default "/images/login-bg.png?820bff4b903862544540f68ef5423f34";